import type { ContentElementExternalLinksProps } from '@vgn-medien-holding/vgn-fe-components';

const classProps = {
  root: 'py-3 lg:p-3 pl-7 lg:pl-8 bg-white mt-4 lg:mt-6 pr-2 border-y-0.5 border-gray-650/25 shadow-card-sm',
  link: 'underline decoration-current underline-offset-2 transition-colors duration-300 hover:text-black text-primary list-disc py-2',
} as ContentElementExternalLinksProps['classProps'];

export default classProps;
